/*
* Copyright 2026 Tecnalia, Basque Research & Technology Alliance (BRTA)
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*
*  SPDX-License-Identifier: Apache-2.0
*/

import { AppConfigService } from '../../../core/services/app-config/app-config.service';
import { AuthService } from '../../services/auth.service';
import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
	selector: 'app-logged-in',
	imports: [],
	templateUrl: './logged-in.component.html',
	styleUrl: './logged-in.component.scss',
})

export class LoggedInComponent {

	constructor(
		private router: Router,
		private authSvc: AuthService,
		private configSvc: AppConfigService
	) {
		this.authSvc.reachedLoggedInCallbackUrl();
		this.router.navigate([this.configSvc.settings.rootUrlPath]);
	}

}